import { Component, OnDestroy, ViewChild, EventEmitter } from "@angular/core";
import { cloneDeep } from "lodash";
import { Subscription } from "rxjs";
import { CclMessageService, CclNavbarSecondaryService } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";

@Component({
    selector: "setting",
    templateUrl: "./setting.view.html",
    providers: []
})
export class SettingView implements OnDestroy {
    subscription: Subscription;
    buttonConfig: any = {};

    constructor(
        private sharedService: SharedService,
        private messageService: CclMessageService,
        private navSecondaryService: CclNavbarSecondaryService,
        ) {
        this.navSecondaryService.sectionLabel = "Additional Settings";
    }

    ngOnDestroy() {
    }
}
